import { request } from '@services'
import { i18n } from '@plugins/i18n'
import { STATUS_REQUEST } from '@utils/constant'

export const state = {
  loading: false,
  status: null,
  errors: null,
}

export const getters = {
  getStatus(state) {
    return state.status
  },
  getErrors(state) {
    return state.errors
  },
}

export const mutations = {
  SET_REGISTRATION_AGENT_REQUESTED(state) {
    state.loading = true
  },
  SET_REGISTRATION_AGENT_RECEIVED(state) {
    state.loading = false
    state.status = STATUS_REQUEST.SUCCESS
    state.errors = null
  },
  SET_REGISTRATION_AGENT_FAILED(state, errors) {
    state.loading = false
    state.status = STATUS_REQUEST.FAILED
    state.errors = errors
  },
  RESET_REGISTRATION_AGENT(state) {
    state.loading = false
    state.status = null
    state.errors = null
  },
}

export const actions = {
  async registrationAgent({ commit }, params) {
    commit('SET_REGISTRATION_AGENT_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/agent/add/',
        payload: {
          ...params,
          level: 1,
          phone: '',
          exit_message: i18n.t('agent.default_exit_message'),
        },
      })
      commit('SET_REGISTRATION_AGENT_RECEIVED')
      return response
    } catch (error) {
      commit('SET_REGISTRATION_AGENT_FAILED', error)
    }
  },
  resetRegistrationAgent({ commit }) {
    commit('RESET_REGISTRATION_AGENT')
  },
}
